import styled, { css } from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';
import { verticalAlignToAlignItems } from 'styled/mixins/gridOrFlexLayoutMixin';
import type { Dimension } from 'styled/types';

export interface GridContainerProps {
  columns?: 1 | 2 | 3 | 4 | 5 | 6;
  gap?: number;
  verticalAlign?: 'top' | 'center' | 'bottom';
}

export const GridContainer = styled.div<GridContainerProps>`
  ${({ theme, columns = 3, gap = 10, verticalAlign = 'center' }) => css`
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    gap: ${getDimension(`size${gap}` as Dimension)};
    grid-auto-flow: unset; /* use the grid-template below */
    grid-template-columns: repeat(${columns}, 1fr);

    align-items: ${verticalAlignToAlignItems[verticalAlign]};

    ${theme.breakpoints.down('md')} {
      grid-template-columns: 1fr; /** This should always span screen width. */
      grid-auto-flow: row;
    }
  `}
`;
